import "./App.css";

import { BrowserRouter, Route, Switch } from "react-router-dom";

import AppHeader from "./components/app-header/AppHeader";
import Login from "./components/login/Login";
import { t } from "./utils/ResourceUtils";
import TenantExtractor from "./utils/TenantExtracter";

const App = () => {
  const tenant = TenantExtractor.getTenant();
  const product = TenantExtractor.getProduct();
  const loginResponse = JSON.parse(localStorage.getItem("loginResponse"));

  return (
    <BrowserRouter>
      <Switch>
        <Route path="/health">
          <h1>{t("cm.hey_the_app_is_healthy")}</h1>
        </Route>
        {loginResponse ? <AppHeader /> : <Login tenant={tenant} product={product} enableSingleSignOn={true} />}
      </Switch>
    </BrowserRouter>
  );
};

export default App;
